import { decideDirectApproval } from "@/api/task-workers";

export type ApprovalDecision = "approve" | "reject";

/** A coding session's tool approval on its task. */
export interface ApprovalTarget {
  projectId: string;
  taskId: string;
  approvalId: string;
}

/** Decides an approval; used by the hub, the bell and the approval card. Throws on failure. */
export async function decideApproval(
  target: ApprovalTarget,
  decision: ApprovalDecision,
): Promise<void> {
  await decideDirectApproval(
    target.projectId,
    target.taskId,
    target.approvalId,
    decision === "approve",
  );
}
